import { BadgeStatus } from "@/types";

export const convertKpiToBadgeColor = (color: string): BadgeStatus => {
  switch (color) {
    case "Green":
      return "success";
    case "Yellow":
      return "warning";
    case "Red":
      return "error";
    default:
      return "default";
  }
};
